import __var_0__ from './main.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Evaluate the ramp function.
*
* @module @stdlib/math/base/special/ramp
*
* @example
* var ramp = require( '@stdlib/math/base/special/ramp' );
*
* var v = ramp( 3.14 );
* // returns 3.14
*
* v = ramp( -3.14 );
* // returns 0.0
*
* v = ramp( NaN );
* // returns NaN
*/

// MODULES //
var ramp = __var_0__;


// EXPORTS //
export default ramp;
